import { render, staticRenderFns } from "./add-profile-card.vue?vue&type=template&id=6f8a47ac&scoped=true&"
import script from "./add-profile-card.vue?vue&type=script&lang=js&"
export * from "./add-profile-card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f8a47ac",
  null
  
)

export default component.exports